import { Box, Text } from '@mantine/core';

import { EvalMethodAiHsCode, TaricOtherMeasures } from '@e-origin/shared';

import { HS_CODE_DESC_LIMIT, HS_CODE_MAGNITUDE_FACTOR } from '@constants';
import { classes as globalClasses } from '@styles';
import classes from './HSCodeDescriptionField.module.css';

interface HsCodeElement {
  title: string;
  description: string;
  magnitude: number;
}

interface HSCodeDescriptionFieldProps {
  taricDescriptionList: EvalMethodAiHsCode['taricDescriptionList'];
  taricDescriptionListException: EvalMethodAiHsCode['taricDescriptionListException'];
  taricOtherMeasures: EvalMethodAiHsCode['taricOtherMeasures'];
}

export const HSCodeDescriptionField: React.FC<HSCodeDescriptionFieldProps> = (props: any) => {
  const { taricDescriptionList, taricDescriptionListException, taricOtherMeasures } = props;

  const reduceHsCode = (taricArray: string[][]): HsCodeElement[] => {
    return taricArray.map((element: any) => {
      const code: string = element[0];
      let newCode = '';
      for (let i = 0; i < element[0].length; i += HS_CODE_DESC_LIMIT) {
        if (!code[i + 1] || (code[i] === '0' && code[i + 1] === '0')) break;

        newCode += code[i] + code[i + 1];
      }
      const numberOfdashes = element[1].split(' ').join('').length;

      return { title: newCode, description: element[HS_CODE_DESC_LIMIT], magnitude: numberOfdashes };
    });
  };

  const renderTaricSection = (sectionTitle: string, HsCodelist: HsCodeElement[]) => {
    return (
      <>
        <Text className={classes.label}>{sectionTitle}</Text>
        <Box className={classes.content}>
          {HsCodelist.map((hsCode, index) => (
            <Box className={classes.hsCodeListItem} key={index} ml={hsCode.magnitude * HS_CODE_MAGNITUDE_FACTOR}>
              <Text className={classes.hsCodeTitle}>{hsCode.title}</Text>
              <Box className={classes.hsCodeDescription}>{hsCode.description}</Box>
            </Box>
          ))}
        </Box>
      </>
    );
  };

  const renderOtherMeasures = (sectionTitle: string, taricOtherMeasureList: TaricOtherMeasures[]) => {
    return (
      <>
        <Text className={classes.label}>{sectionTitle}</Text>
        <Box className={classes.content}>
          {taricOtherMeasureList.map((taricOtherMeasure, index) => (
            <Box className={classes.hsCodeListItem} key={index}>
              <Text className={classes.hsCodeTitle}>{taricOtherMeasure.measureType}</Text>
              <Box className={classes.hsCodeDescription}>{taricOtherMeasure.duty}</Box>
            </Box>
          ))}
        </Box>
      </>
    );
  };

  const hsCodeDescriptionList = reduceHsCode(taricDescriptionList);
  const hsCodeDescriptionListException = reduceHsCode(taricDescriptionListException);

  return (
    <div>
      <Box className={`${classes.container} ${globalClasses.inputBorder}`}>
        {renderTaricSection('HS Code description', hsCodeDescriptionList)}
        {renderTaricSection('Other HS codes', hsCodeDescriptionListException)}
        {renderOtherMeasures('HS code TARIFF (exceptions) and NON-TARIFF (restrictions)', taricOtherMeasures)}
      </Box>
    </div>
  );
};
